import { useContext } from 'react';
import { TechnologiesContext } from '../components/context/technologies-context';
export const useTechnologies = () => useContext(TechnologiesContext);